<style >
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.activeClass{
  background: #fff!important;
}
</style>
<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { authComputed } from "@/state/helpers";
import ApplicationCreate from "./application_create.vue"
import StatusQuery from "./status_query.vue"

export default {
  page: {
    title: "Başvuru Listesi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ApplicationCreate,
    StatusQuery
  },
  data() {
    return {
      title: "BAŞVURU LİSTESİ",
      items: [
        {
          text: "ANASAYFA",
          href: "/",
        },
        {
          text: "BAŞVURU LİSTESİ",
          active: true,
        },
      ],
      data:{},
      queryProps:{},
      appPointList:[],
      detailSearch:false,
      copy_index:null,
      list:{
        groups:[],
        dealers:[],
        tariffs:[],
      },
      filter:[],
      form:{},
      isLoading: false,
      rows: [],
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: [
          {
            field: '',
            type: '',
          },
        ],
        page: 1,
        perPage: 50,
      },
      currentPage: 0,
      selected: 0,
      pageLength: 0,
        url: "members/application",
        paginationOptions: {
        enabled: true,
        dropdownAllowAll: false,
        perPage: 50,
        setCurrentPage: 1,
        perPageDropdown: [50, 100, 200],
        nextLabel: 'Sonraki',
        prevLabel: 'Önceki',
        rowsPerPageLabel: 'Kayıt Göster',
        ofLabel: 'of',
        pageLabel: 'sayfa', // for 'pages' mode
        infoFn: params => `${params.firstRecordOnPage} - ${params.lastRecordOnPage} ( Toplam: ${params.totalRecords}) `,
      },
      selectOptions: {
        enabled: false,
        selectOnCheckboxOnly: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'adet kayıt seçildi',
        clearSelectionText: 'seçimi iptal et',
        disableSelectInfo: false,
        selectAllByGroup: false,
      },
      columns: [
        {	
          field: '#',
          sortable: false,
          thClass: 'width-50',
        },
        {
          label: 'Başvuru Tarihi',
          field: 'created_at',
          sortable: false,
        },
        {
          label: 'Tc',
          field: 'tc_vkn',
          sortable: false,
        },
        {
          label: 'İsim Soyisim',
          field: this.fullname,
        },
        {
          label: 'Telefon',
          field: 'phonenumber',
        },
        {
          label: 'Başvuru Tipi',
          field: 'type',
        },
        {
          label: 'Durum',
          field: 'status_format',
        },
        {
          label: 'Tam Adres',
          field: 'address',
        }, 
        {
          label: 'Bayi',
          field: 'user_name',
        },
        {
          label: 'Not',
          field: 'note1',      
          sortable: false,
        }
      ],
    };
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.loadItems()
    this.$http.post('/users')
    .then(resp => {
        this.appPointList = resp.data.data
    })
    .catch(error => error)
  },
  methods: {
    fullname(props) {
      return props.fname + ' ' + props.lname
    },
    updateParams(newProps) {
      this.serverParams = { ...this.serverParams, ...newProps }
    },
    onPageChange(params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange(params) {
      this.updateParams({
        sort: params,
      })
      this.loadItems()
    },
    onColumnFilter(params) {
      this.updateParams(params)
      this.loadItems()
    },
    loadItems() {
      this.getFromServer(this.serverParams).then(response => {
        this.totalRecords = response.totalRecords
        this.pageLength = response.pageLength
        this.currentPage = response.currentPage
        this.rows = response.rows
      })
    },
    getFromServer() {
      return new Promise((resolve, reject) => {
        this.$http.post(this.url, this.serverParams)
          .then(res => {
            resolve({
              rows: res.data.data,
              totalRecords: res.data.total,
              pageLength: res.data.last_page,
              currentPage: res.data.current_page,
            })
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    fieldFn(rowObj) {
      return rowObj.nameozet
    },
    onSearch(params) {
      this.updateParams(params)
      this.loadItems()
    },
    detail(props) {
      this.data = {...props}
      this.$parent.$bvModal.show('modal-application')
    },
    statusQuery(props){
      const { fname,lname,address,bbk,created_at,id } = props
      const fullname = fname +' ' + lname
      this.queryProps = { fullname,address,bbk,created_at,id }
      this.$parent.$bvModal.show('status_query')
    },
    selectionChanged(a) {
      this.selected = a.selectedRows.length
    },
    formSubmit(){
      this.updateParams({columnFilters : {...this.form}});
      this.loadItems()
    },
    createClient(props){
      this.$router.push({name:"musteri-ekle", query:{ "appId":props.id}})
    },
    allClear(){
      this.form = {}
    }
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <ApplicationCreate :data="data" />
    <StatusQuery :data="queryProps" />
    <div class="row mb-3">
        <div class="col-md-4 offset-lg-8 text-end">
             <button 
                class="btn btn-outline-light bg-light" 
                :class="{ activeClass: detailSearch }"
                type="button"  
                @click="detailSearch = !detailSearch">
                <i class="bx bx-filter-alt"></i> Detaylı Arama
            </button>
        </div>
     
      <Transition  name="fade" v-if="detailSearch">
        <div class="col-lg-6 offset-lg-6">
          <div class="card">
            <div class="card-body">
              <form class="needs-validation" @submit.prevent="formSubmit">
                <div class="row">
                  <div class="col-xl-6">
                    <div class="mb-3">
                      <label for="">Başvuru Noktası</label>
                      <v-select
                            label="name" 
                            v-model="form.app_point"
                            :options="appPointList" 
                            :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="mb-3">
                      <label for="">Başvuru Durumu</label>
                      <v-select
                              label="name" 
                              v-model="form.status"
                              :options="[{id:'0',name:'Bekleyen'}, {id:'1',name:'Tamamlanmış'}, {id:'2',name:'İptal'}]" 
                              :reduce="df => df.id">
                        <span slot="no-options">Sonuç Bulunamadı</span>
                      </v-select>
                    </div>
                  </div>
              </div>
                <div class="row">
                  <div class="col-md-6 offset-md-6 text-end">
                    <div class="button-items">
                       <button 
                          type="submit"
                          class="btn btn-outline-danger"  
                          @click="allClear()" 
                          >
                          Sorguyu Temizle
                        </button>
                        <button 
                          type="submit"
                          class="btn btn-primary"   
                          >
                           Sorgula
                        </button>
                    </div>
                  </div>
                </div>    
              </form>
              <!-- end card -->
          </div>
        </div>
      </div>
    </Transition>
      <!-- end col -->
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
             <vue-good-table
                mode="remote"
                :total-rows="totalRecords"
                :columns="columns"
                :rows="rows"
                @on-search="onSearch"
                :search-options="{
                  enabled: true,
                  placeholder: 'Kullanıcı adı, isim, soyisim alanlarında en az 3 harf ile arama yapınız'
                }"
                :select-options="selectOptions"
                :pagination-options="paginationOptions"
                :is-loading.sync="isLoading"
                @on-selected-rows-change="selectionChanged"
                @on-page-change="onPageChange"
                @on-sort-change="onSortChange"
                @on-column-filter="onColumnFilter"
                @on-per-page-change="onPerPageChange">
                <template slot="loadingContent">
                  <div>Yükleniyor</div>
                </template>
                <template
                  slot="table-row"
                  slot-scope="props"
                >
                  <span
                    v-if="props.column.field === '#'"
                    class="text-nowrap"
                  >
                    <ul class="list-inline font-size-20 contact-links mb-0">
                      <li class="list-inline-item">
                          <a  title="Müşteri Ekle" @click="createClient(props.row)">
                          <i class="bx bx-user"></i>
                        </a>
                      </li>
                      <li class="list-inline-item">
                          <a title="Detay" @click="detail(props.row)">
                          <i class="bx bx-search-alt-2"></i>
                        </a>
                      </li>
                       <li class="list-inline-item">
                          <a title="Durum Sorgula" @click="statusQuery(props.row)">
                          <i class="mdi mdi-alpha-b-circle-outline"></i>
                        </a>
                      </li>
                    </ul>
                  </span>
                  <span
                    v-else-if="props.column.field === 'status_format'"
                    class="text-nowrap"
                  >
                    <span v-if="props.row.status == 0" class="badge rounded-pill bg-primary">Bekliyor</span>
                    <span v-if="props.row.status == 1" class="badge rounded-pill bg-success">Tamamlanmış</span>
                    <span v-if="props.row.status == 2" class="badge rounded-pill bg-danger">İptal</span>
                  </span>
                  <span v-else-if="props.column.field == 'address'">
                  {{ props.row.address.address }}
                  </span>
                </template>
             </vue-good-table>
        </div>
      </div>
    </div>
  </Layout>
</template>